import jwt_decode from "jwt-decode";
import { authStore } from "./authStore";
import { PENDING_2FA_STATUSES } from "./constants";

/**
 * Handle portal login API response — 2FA statuses take priority over access_token.
 */
export function handlePortalLoginResponse(data, handlers) {
  const {
    dispatch,
    navigate,
    setTokenAndUserData,
    handleAuthStatusRedirect,
    handleLoginNavigation,
    setUser,
  } = handlers;

  const status = data.data?.status;
  const accessToken = data.data?.access_token;
  const interimToken = data.data?.token;

  if (status && PENDING_2FA_STATUSES.includes(status) && interimToken) {
    authStore.setPendingAccessToken(interimToken);

    const decodedToken = jwt_decode(interimToken);
    dispatch(
      setUser({
        email: decodedToken.email,
        userId: decodedToken.id,
      }),
    );
    handleAuthStatusRedirect(status, navigate);
    return { type: "2fa", status };
  }

  if (accessToken) {
    setTokenAndUserData(accessToken);
    const decodedToken = jwt_decode(accessToken);
    handleLoginNavigation(decodedToken.isSideNav, status, false, {
      isAccountApproved: decodedToken.isAccountApproved,
      isEmailVerified: decodedToken.isEmailVerified,
      isPending: decodedToken.isPending,
      authStatus: decodedToken.authStatus,
    });
    return { type: "full", status };
  }

  return { type: "unknown" };
}

/**
 * Handle admin login API response (no refresh cookie).
 */
export function handleAdminLoginResponse(data, handlers) {
  const {
    dispatch,
    navigate,
    setTokenAndUserData,
    handleAdminAuthStatusRedirect,
    setUser,
    onAdminFullLogin,
  } = handlers;

  const status = data.data?.status;
  const accessToken = data.data?.access_token;
  const interimToken = data.data?.token;

  if (status && PENDING_2FA_STATUSES.includes(status) && interimToken) {
    authStore.setPendingAccessToken(interimToken);

    const decodedToken = jwt_decode(interimToken);
    dispatch(
      setUser({
        email: decodedToken?.email,
        userId: decodedToken?.id,
        isAdmin: true,
      }),
    );
    handleAdminAuthStatusRedirect(status, navigate);
    return { type: "2fa", status };
  }

  if (accessToken) {
    setTokenAndUserData(accessToken, { isAdmin: true });
    onAdminFullLogin?.();
    return { type: "full", status };
  }

  return { type: "unknown" };
}
